'use client';

import dynamic from 'next/dynamic';
import type { ArticlesDataSourceProps } from '../../types';

const ArticlesListingViewModel = dynamic(() => import('../articles-listing-view-model'));

const ArticlesListingClientWrapper = (props: ArticlesDataSourceProps) => <ArticlesListingViewModel {...props} />;

export default ArticlesListingClientWrapper;
